import emailjs from '@emailjs/browser';

const EMAILJS_SERVICE_ID = 'service_nmd5v6m';
const EMAILJS_TEMPLATE_ID = 'template_67d0pzh';
const EMAILJS_PUBLIC_KEY = '0tm_DPnR8Gw-Fuvig';

// Initialize EmailJS with the public key
emailjs.init(EMAILJS_PUBLIC_KEY);

interface EmailData {
  name: string;
  email: string;
  message: string;
  type: string;
  book_title?: string;
  book_author?: string;
}

export async function sendEmail(data: EmailData): Promise<void> {
  try {
    const templateParams = {
      from_name: data.name,
      from_email: data.email,
      message: data.message,
      type: data.type,
      book_title: data.book_title || '',
      book_author: data.book_author || ''
    };

    await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY
    );
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
}